export const Gauge: React.FC<React.SVGAttributes<SVGSVGElement>> = props => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 110 110"
    fill="#003057"
    {...props}
  >
    <path d="M11.699,91.000A50,50 0 1 1 98.301,91.000L91.070,86.825A41.65,41.65 0 1 0 18.930,86.825Z" />
    <circle cx="15.314" cy="88.913" r="4.175" />
    <circle cx="94.686" cy="88.912" r="4.175" />
    <path d="M50.021,61.822L76.212,40.721L59.979,70.178Z" />
    <circle cx="55" cy="66" r="8.5" />
  </svg>
)
